export class LeaderboardPlayer {
  constructor(data = {}) {
    this.boomAccountId = data.boomAccountId;
    this.name = data.name;
    this.position = data.leaderboardPosition;
    this.avatar = data.avatar;
    this.points = data.points;
    this.displayText = data.displayText;
    this.score = data.score;
    this.leaderboardType = data.leaderboardType;
    this.changeInPosition = data.changeInPosition;
    this.displayname = data.displayname;
  }
}
